import React from "react";
import EN from "../../locales/en";
import { substituteLinksInText } from "../../utils/switching";
import DisclosureSection from "./partials/DisclosureSection";
import RadioField from "./partials/RadioField";

const SmartMeterReadingFrequency = ({ config, isSubmitting }) => (
  <div className="mt-8 border-t border-[#afb6b9]">
    <h2 className="text-[30px] font-bold text-primary mt-6">
      {EN.switch.smart_meter_reading_frequency.title}
    </h2>
    <p className="text-md leading-[1.5] mt-2">{config?.title}</p>

    <p className="font-semibold mt-6">{config?.consents[0]?.title}</p>
    {config?.consents[0]?.options?.map((option, index) => (
      <RadioField
        key={index}
        name="customerInfo.billingConsentLevel"
        label={option?.displayText}
        value={option?.value}
        hideErrorMessage={index !== config?.consents[0]?.options?.length - 1}
        disabled={isSubmitting}
      />
    ))}

    <p className="font-semibold mt-6">{config?.consents[1]?.title}</p>
    <DisclosureSection
      title={config?.consents[1]?.hint?.displayText}
      content={
        <p>
          {substituteLinksInText(
            config?.consents[1]?.hint?.message,
            config?.consents[1]?.hint?.links
          )}
        </p>
      }
    />
    {config?.consents[1]?.options?.map((option, index) => (
      <RadioField
        key={index}
        name="customerInfo.settlementConsentLevel"
        label={option?.displayText}
        value={option?.value}
        hideErrorMessage={index !== config?.consents[1]?.options?.length - 1}
        disabled={isSubmitting}
      />
    ))}
  </div>
);

export default SmartMeterReadingFrequency;
